<header class="dialog-header">
  <div class="dialog-header__text">
    <h1 mat-dialog-title class="dialog-header__title">{{ heading }}</h1>
    @if (subheading) {
      <p class="dialog-header__subtitle">{{ subheading }}</p>
    }
  </div>
  @if (contextValue) {
    <span class="dialog-header__context">
      @if (contextLabel) {
        <span class="dialog-header__context-label">{{ contextLabel }}</span>
      }
      {{ contextValue }}
    </span>
  }
  @if (showClose) {
    <button mat-icon-button type="button" [mat-dialog-close]="closeResult" aria-label="Close" class="dialog-header__close">
      <mat-icon>close</mat-icon>
    </button>
  }
</header>
